const initColumnsTextWithGalleryAndBackgroundWidget = () => {
    const selectorT1 = "[data-columns-text-with-gallery-and-background-widget].typology-1 [data-carousel]";
    const carouselT1 = document.querySelector(selectorT1);
    if (carouselT1) {
        const config = new CarouselConfig();
        config.sliderSelector = selectorT1;
        config.cellAlign = CellAlign.left;
        config.contain = true;
        config.autoPlay = false;
        config.wrapAround = false;
        config.showArrows = false;
        config.showDots = false;
        config.groupCells = false;
        config.adaptiveHeight = true;
        config.imagesLoaded = true;
        config.activateCustomButtons = true;
        const responsiveCarousel = new ResponsiveCarousel();
        responsiveCarousel.initCarousel(config);
    }
};
